import React from 'react';
import { IMaskInput } from 'react-imask';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value: string;
}

const CepMask = React.forwardRef<HTMLInputElement, Props>(
  function CepMask(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="00000-000"
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  }
);

export default CepMask;
